import { render } from "./ChatFeedbackPhoneNumber.vue?vue&type=template&id=774822a4"
import script from "./ChatFeedbackPhoneNumber.vue?vue&type=script&lang=js"
export * from "./ChatFeedbackPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__